import React, { useEffect, useState } from 'react';
import { Button, Jumbotron, Table } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { loadRequest } from '~/store/modules/downloads/actions';
// eslint-disable-next-line
import FileDownload from '~/Components/FileDownload';
import Waiter from '~/Components/Waiter';
import { Section } from '../styles';

function FormConsultaPermissaoAtividade() {
	const dispatch = useDispatch();
	const { data: downloads, loading, error } = useSelector((e) => e.downloads);
	const [currentDownloads, setCurrentDownloads] = useState(null);

	useEffect(() => {
		if (!downloads) dispatch(loadRequest());
	}, [downloads, dispatch]);

	useEffect(() => {
		if (downloads) {
			const [current] = downloads.filter(
				(e) => e.key === 'permissao-de-atividade'
			);
			setCurrentDownloads(current);
		}
	}, [downloads]);

	return (
		<>
			<Section>
				{currentDownloads && (
					<Jumbotron style={{ background: 'transparent' }}>
						<h1 className="display-6">
							Consulta Permissão de Atividade
						</h1>
						<p className="lead">
						Secretaria Municipal de Planejamento e Fiscalização Urbana e Meio Ambiente
						</p>
						<hr className="my-2" />
						<br />
						{loading && <Waiter style={{ position: 'absolute' }} />}
						{!currentDownloads && !loading && !error && (
							<p>Esta categoria ainda não possui arquivos.</p>
						)}
						<p className="lead">
							{!(
								!error &&
								!loading &&
								!currentDownloads.downloads[0]
							) &&
								currentDownloads.complement?.trim() &&
								currentDownloads.complement}
							{error &&
								'Houve num erro ao tentar carregar os documentos.'}
						</p>

						{error && (
							<p className="lead">
								<Button
									type="button"
									color="info"
									onClick={() => window.location.reload()}
								>
									Tentar novamente
								</Button>
							</p>
						)}

						<Table hover>
							<tbody>
								{currentDownloads.downloads.map((e, i) => (
									<FileDownload key={String(i)} data={e} />
								))}
							</tbody>
						</Table>
					</Jumbotron>
				)}
			</Section>
		</>
	);
}

export default FormConsultaPermissaoAtividade;
